import React from "react";
import { Box, Tooltip } from "@material-ui/core";
import { get, pick } from "lodash";
import { useStyles } from "../styles";
import { targetStatusColor, targetStatusTxtColor } from "../../constants";
import { GRID_STATUS, GRID_TARGET_STATUS } from "src/constants/literalConstant";
import { STATUS } from "src/constants";

const TargetStatus = ({ colProps, isCheckin }) => {
  const classes = useStyles();
  const status = get(colProps, "dataItem.userTargetStatus", "")
    ? STATUS[get(colProps, "dataItem.userTargetStatus", "")]
    : STATUS[get(colProps, "dataItem.targetStatus", "")]
    ? STATUS[get(colProps, GRID_TARGET_STATUS, "")]
    : STATUS[get(colProps, GRID_STATUS, "")] || get(colProps, GRID_STATUS, "");

  const statusColor = pick(targetStatusColor, status);
  // const statusColor = status === "Paused" ? {Paused: '#D1F8F2'} :  pick(targetStatusColor, status);
  const statusTxtColor = pick(targetStatusTxtColor, status);

  const renderStatus = (status) => {
    let viewStatus = status;
    if (status === "Pendingapproval") {
      viewStatus = "Pending";
    } else if (status === "Completed" && !isCheckin) {
      viewStatus = "Closed";
    }

    return viewStatus;
  };

  return (
    <td>
      <Box display={"flex"} alignItems="center" justifyContent="center">
        <Tooltip title={renderStatus(status)}>
          <span
            className={`${classes.statusBg} truncate-txt target-status`}
            style={{
              backgroundColor: statusColor[status],
              color: statusTxtColor[status],
            }}
          >
            {renderStatus(status)}
          </span>
        </Tooltip>
      </Box>
    </td>
  );
};

export default TargetStatus;
